export default {
  isMobile: !!process.env.REACT_APP_IS_MOBILE,
};
